import { render, staticRenderFns } from "./ProductStockView.vue?vue&type=template&id=6e56ed21"
import script from "./ProductStockView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStockView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductStockView.vue?vue&type=style&index=0&id=6e56ed21&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports